/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQueryResourceType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQueryResourceType");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQueryResourceType.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQueryResourceType>): AutomationTemplateQueryResourceType {
        let obj = Object.assign(new AutomationTemplateQueryResourceType(), model);
        AutomationTemplateQueryResourceType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQueryResourceType>): AutomationTemplateQueryResourceType {
        if (!model) return null;
        return AutomationTemplateQueryResourceType.newInstance(<AutomationTemplateQueryResourceType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQueryResourceType) {
        if (!obj) return;

        models.AutomationTemplateQueryResourceType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQueryResourceType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQueryResourceType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template resource types to include
     */
    resource_types: Array<string>;

}
